import moment from 'jalali-moment';
import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { STORAGE_CART_KEY } from '@/configs';
import storage from '../helpers/storage';

export interface CartProgram {
  id: number;
  selectedCount: number;
  food: any;
}

export interface CartSlice {
  expireAt: number;
  selectedSelfId: number;
  programs: CartProgram[];
  addToCart: (args: { id: number; food: UserWeekReserveEntity }, countToAdd?: number) => void;
  removeFromCart: (id: number, countToRemove?: number) => void;
  emptyBasket: () => void;
  remainingTime: () => number;
  remainingTimeString: () => string;
  findItemById: (id: number) => CartProgram;
  getTotalItemsCount: () => number;
}

type CartPayload = Partial<CartSlice>

const CART_EXPIRE_TIME = 60 * 15;
// const CART_EXPIRE_TIME = 5;

const writeCartToStorage = (payload: any) => storage.writeJSON(STORAGE_CART_KEY, payload);

const readCartFromStorage = () => storage.readJSON(STORAGE_CART_KEY, {
  selectedSelfId: null,
  programs: [],
  expireAt: -1
});

const initialState = readCartFromStorage() as CartSlice;

const mutations = (
  setState: (...params: Partial<CartSlice>[]) => any,
  getState: () => CartSlice
) => {
  return {
    selectedSelfId: null,

    addToCart: ({ id, food }, countToAdd: number = 1) => {
      const programs = getState().programs;
      const programIndex = programs.findIndex(x => x.id === id);
      const expireAt = moment().unix() + CART_EXPIRE_TIME;

      let payload: CartPayload;
      if (programIndex < 0) {
        payload = { programs: [...programs, { id, food, selectedCount: countToAdd }], expireAt };
      }
      else {
        programs[programIndex].selectedCount += countToAdd;
        payload = { programs: [...programs], expireAt };
      }
      setState(payload);
      writeCartToStorage(payload);
    },

    removeFromCart: (id: number, countToRemove = 1) => {

      const programs = getState().programs;
      const programIndex = programs.findIndex(x => x.id === id);

      if (programIndex < 0) return;
      programs[programIndex].selectedCount -= countToRemove;
      if (programs[programIndex].selectedCount < 0) {
        programs[programIndex].selectedCount = 0;
      }
      const isEmpy = programs[programIndex].selectedCount === 0;
      const payload = {
        programs: isEmpy ? programs.filter(p => p.id != id) : [...programs]
      };
      setState(payload);
      writeCartToStorage(payload);
    },

    remainingTime: () => {
      const { expireAt } = getState();
      const result = expireAt - moment().unix();
      return result >= 0 ? result : -1;
    },

    remainingTimeString: () => {
      const time = getState().remainingTime();
      const timeM = Math.floor(time / 60);
      const timeS = time % 60;
      return `${timeM}:${timeS}`;
    },

    findItemById: (id: number) => {
      return getState().programs.find(p => p.id === id);
    },

    getTotalItemsCount: () => {
      let result = 0;
      for (const program of getState().programs) {
        result += program.selectedCount;
      }
      return result;
    },

    emptyBasket: () => {
      setState({ programs: [] });
      writeCartToStorage({ programs: [] });
    }
  };
};

export default create(combine(initialState, mutations as any));
